function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isMobile, replaceWith } from "@common/services/helpers";
import { APP_BANNER_DEVICE_INFO as deviceInfo } from "@config/constants";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { connect } from "react-redux";
export var DownloadAppBanner = function(props) {
    var _deviceInfo_deviceType, _info_i18n, _info_i18n1, _info_i18n_messageExtra, _info_i18n2;
    if (!deviceInfo) {
        return null;
    }
    var i18n = props.i18n, screenType = props.screenType, darkBackground = props.darkBackground, onBannerChange = props.onBannerChange;
    var _useState = _sliced_to_array(useState({
        open: false,
        deviceType: "phone",
        os: "android"
    }), 2), bannerState = _useState[0], setBannerState = _useState[1];
    var os = bannerState.os, open = bannerState.open, deviceType = bannerState.deviceType;
    useEffect(function() {
        var isClosed = sessionStorage.getItem("appBannerClosed") === "true";
        if (isClosed) return;
        var newBannerState = {
            open: false,
            deviceType: "",
            os: ""
        };
        var isMobileOs = false;
        if (isMobile.Android()) {
            newBannerState.os = "android";
            isMobileOs = true;
        }
        if (isMobile.iOS()) {
            newBannerState.os = "ios";
            isMobileOs = true;
        }
        if (screenType.mobile && isMobileOs) {
            newBannerState.deviceType = "phone";
            newBannerState.open = true;
        }
        if (screenType.tablet && isMobileOs) {
            newBannerState.deviceType = "tablet";
            newBannerState.open = true;
        }
        if (isMobile.Tizen()) {
            newBannerState.os = "tizen";
            newBannerState.deviceType = "tv";
            newBannerState.open = true;
        }
        if (isMobile.WebOS()) {
            newBannerState.os = "webos";
            newBannerState.deviceType = "tv";
            newBannerState.open = true;
        }
        onBannerChange === null || onBannerChange === void 0 ? void 0 : onBannerChange(newBannerState);
        setBannerState(newBannerState);
    }, [
        screenType,
        onBannerChange
    ]);
    var onClose = useCallback(function() {
        setBannerState(function(bannerState) {
            var newBannerState = _object_spread_props(_object_spread({}, bannerState), {
                open: false
            });
            onBannerChange === null || onBannerChange === void 0 ? void 0 : onBannerChange(newBannerState);
            return newBannerState;
        });
        sessionStorage.setItem("appBannerClosed", "true");
    }, [
        onBannerChange
    ]);
    var info = ((_deviceInfo_deviceType = deviceInfo[deviceType]) === null || _deviceInfo_deviceType === void 0 ? void 0 : _deviceInfo_deviceType[os]) || {};
    var title = i18n.appBanner[(_info_i18n = info.i18n) === null || _info_i18n === void 0 ? void 0 : _info_i18n.title] || "";
    var translatedMessage = i18n.appBanner[(_info_i18n1 = info.i18n) === null || _info_i18n1 === void 0 ? void 0 : _info_i18n1.message] || "";
    var emptySpots = translatedMessage.split("").filter(function(c) {
        return c === "{";
    }).length;
    var extraItems = ((_info_i18n2 = info.i18n) === null || _info_i18n2 === void 0 ? void 0 : (_info_i18n_messageExtra = _info_i18n2.messageExtra) === null || _info_i18n_messageExtra === void 0 ? void 0 : _info_i18n_messageExtra.map(function(key) {
        return i18n.appBanner[key];
    })) || [];
    var restLength = emptySpots - extraItems.length;
    var replaceArray = extraItems.concat(Array(restLength > 0 ? restLength : 0).fill(""));
    var message = replaceWith(translatedMessage, replaceArray).trim();
    return open && /*#__PURE__*/ _jsxs("div", {
        className: "download-app-banner-wrapper ".concat(deviceType, " ").concat(darkBackground ? "dark" : ""),
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "icon icon-clear pointer",
                tabIndex: 0,
                onClick: onClose,
                onKeyDown: onClose
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row device-and-logo-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "column device-wrapper",
                        children: /*#__PURE__*/ _jsx("img", {
                            src: info === null || info === void 0 ? void 0 : info.image,
                            alt: "device",
                            className: "device-image"
                        })
                    }),
                    /*#__PURE__*/ _jsx("img", {
                        src: "/assets/media/logo-96x96.png",
                        alt: "logo",
                        className: "logo"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "message-wrapper column",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "message",
                        children: message
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("a", {
                href: info === null || info === void 0 ? void 0 : info.appURL,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "store-image-link",
                children: /*#__PURE__*/ _jsx("img", {
                    src: info === null || info === void 0 ? void 0 : info.storeImage,
                    alt: "store",
                    className: "store-image"
                })
            }),
            deviceType === "tv" && /*#__PURE__*/ _jsx("img", {
                src: "/assets/media/app-banner/hand-with-remote.png",
                alt: "hand-with-remote",
                className: "hand-with-remote-image"
            })
        ]
    });
};
var mapStateToProps = function(param) {
    var i18n = param.i18n, screenType = param.screenType;
    return {
        i18n: i18n,
        screenType: screenType
    };
};
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(DownloadAppBanner);
